"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentReference = exports.ContentReferenceMeta = void 0;
var FragmentMeta_1 = require("./FragmentMeta");
/**
 * Class providing meta data about an Content Reference resource.
 * @deprecated use FragmentMeta
 */
var ContentReferenceMeta = /** @class */ (function (_super) {
    __extends(ContentReferenceMeta, _super);
    function ContentReferenceMeta(data) {
        return _super.call(this, data) || this;
    }
    return ContentReferenceMeta;
}(FragmentMeta_1.FragmentMeta));
exports.ContentReferenceMeta = ContentReferenceMeta;
/**
 * Class representing an Content Reference.
 */
var ContentReference = /** @class */ (function () {
    function ContentReference(data) {
        Object.assign(this, data);
        if (data && data._meta) {
            this._meta = new ContentReferenceMeta(data._meta);
        }
        if (data && data.contentType) {
            this.contentType = data.contentType;
        }
    }
    /**
     * Export ContentReference to JSON
     */
    ContentReference.prototype.toJSON = function () {
        var id = this.id;
        var result = {
            id: id,
        };
        if (this._meta) {
            result._meta = this._meta.toJSON();
        }
        if (this.contentType) {
            result.contentType = this.contentType;
        }
        return result;
    };
    /**
     * @hidden
     * Returns true if the provided fragment is an content reference
     * @param fragment
     */
    ContentReference.isContentReference = function (fragment) {
        return (FragmentMeta_1.FragmentMeta.isFragment(fragment) &&
            fragment._meta.schema ===
                'http://bigcontent.io/cms/schema/v1/core#/definitions/content-reference');
    };
    return ContentReference;
}());
exports.ContentReference = ContentReference;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGVudFJlZmVyZW5jZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvY29udGVudC9tb2RlbC9Db250ZW50UmVmZXJlbmNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLCtDQUE4QztBQWM5Qzs7O0dBR0c7QUFDSDtJQUEwQyx3Q0FBWTtJQUNwRCw4QkFBWSxJQUFVO2VBQ3BCLGtCQUFNLElBQUksQ0FBQztJQUNiLENBQUM7SUFDSCwyQkFBQztBQUFELENBQUMsQUFKRCxDQUEwQywyQkFBWSxHQUlyRDtBQUpZLG9EQUFvQjtBQU1qQzs7R0FFRztBQUNIO0lBS0UsMEJBQVksSUFBOEI7UUFDeEMsTUFBTSxDQUFDLE1BQU0sQ0FBQyxJQUFJLEVBQUUsSUFBSSxDQUFDLENBQUM7UUFFMUIsSUFBSSxJQUFJLElBQUksSUFBSSxDQUFDLEtBQUssRUFBRTtZQUN0QixJQUFJLENBQUMsS0FBSyxHQUFHLElBQUksb0JBQW9CLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO1NBQ25EO1FBRUQsSUFBSSxJQUFJLElBQUksSUFBSSxDQUFDLFdBQVcsRUFBRTtZQUM1QixJQUFJLENBQUMsV0FBVyxHQUFHLElBQUksQ0FBQyxXQUFXLENBQUM7U0FDckM7SUFDSCxDQUFDO0lBRUQ7O09BRUc7SUFDSCxpQ0FBTSxHQUFOO1FBQ1UsSUFBQSxFQUFFLEdBQUssSUFBSSxHQUFULENBQVU7UUFDcEIsSUFBTSxNQUFNLEdBQTZCO1lBQ3ZDLEVBQUUsSUFBQTtTQUNILENBQUM7UUFFRixJQUFJLElBQUksQ0FBQyxLQUFLLEVBQUU7WUFDZCxNQUFNLENBQUMsS0FBSyxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsTUFBTSxFQUFFLENBQUM7U0FDcEM7UUFFRCxJQUFJLElBQUksQ0FBQyxXQUFXLEVBQUU7WUFDcEIsTUFBTSxDQUFDLFdBQVcsR0FBRyxJQUFJLENBQUMsV0FBVyxDQUFDO1NBQ3ZDO1FBRUQsT0FBTyxNQUFNLENBQUM7SUFDaEIsQ0FBQztJQUVEOzs7O09BSUc7SUFDVyxtQ0FBa0IsR0FBaEMsVUFDRSxRQUEyRDtRQUUzRCxPQUFPLENBQ0wsMkJBQVksQ0FBQyxVQUFVLENBQUMsUUFBUSxDQUFDO1lBQ2pDLFFBQVEsQ0FBQyxLQUFLLENBQUMsTUFBTTtnQkFDbkIsd0VBQXdFLENBQzNFLENBQUM7SUFDSixDQUFDO0lBQ0gsdUJBQUM7QUFBRCxDQUFDLEFBbkRELElBbURDO0FBbkRZLDRDQUFnQiJ9